import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { UserService } from 'src/app/services/user/user.service';
import { InquiryService } from 'src/app/services/inquiry/inquiry.service';
import { USER_TYPES } from 'src/app/config/system.config';

@Component({
  selector: 'app-inquiry-sales-person',
  templateUrl: './inquiry-sales-person.component.html',
  styleUrls: ['./inquiry-sales-person.component.scss']
})
export class InquirySalesPersonComponent extends DestructorComponent implements OnInit {

  @Output() inquiryForwarded = new EventEmitter<void>();

  salesPersonForm!: FormGroup;
  isLoading = false;
  selectedInquiry: any = null;
  salesPersonList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private _userService: UserService,
    private _inquiryService: InquiryService
  ) {
    super();
    this.initializeForm();
  }

  ngOnInit(): void {
    this.setupModalListener();
    this.loadSalesPersonList();
  }

  private initializeForm(): void {
    this.salesPersonForm = this.fb.group({
      sales_person_id: ['', [Validators.required]]
    });
  }

  get sales_person_id() { return this.salesPersonForm.get('sales_person_id'); }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_inquiry_sales_person');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        const selectedInquiry = (window as any).selectedInquiryForForward;
        if (selectedInquiry) {
          this.selectedInquiry = selectedInquiry;
          this.populateForm();
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.resetForm();
      });
    }
  }

  private loadSalesPersonList(): void {
    this.subscriptions.push(
      this._userService.GetData('1', '', { role_type: USER_TYPES.ADMIN, paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            const salesPersons = Array.isArray(response.data) ? response.data : response.data.data || [];
            this.salesPersonList = salesPersons.map((person: any) => ({
              value: person._id || person.doc_id || '',
              label: `${person.title || ''} ${person.name || ''}`.trim()
            }));
          }
        },
        error: (error) => {
          console.error('Error loading sales person list:', error);
          this.salesPersonList = [];
        }
      })
    );
  }

  private populateForm(): void {
    if (this.selectedInquiry) {
      this.salesPersonForm.patchValue({
        sales_person_id: this.selectedInquiry.sales_person_id || ''
      });
    }
  }

  onSubmit(): void {
    if (this.salesPersonForm.valid && !this.isLoading && this.selectedInquiry) {
      this.isLoading = true;

      const formData = this.salesPersonForm.value;
      const updateData = {
        sales_person_id: formData.sales_person_id
      };

      this.subscriptions.push(
        this._inquiryService.UpdateData(this.selectedInquiry._id, updateData).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            if (response.status) {
              (window as any).Swal.fire({
                title: 'Forwarded!',
                text: 'The inquiry has been forwarded to sales person successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
              });
              this.inquiryForwarded.emit();
              this.closeModal();
            } else {
              (window as any).Swal.fire({
                title: 'Error!',
                text: response.message || 'Failed to forward inquiry. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                  confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false
              });
            }
          },
          error: (error) => {
            console.error('Error forwarding inquiry:', error);
            this.isLoading = false;
            (window as any).Swal.fire({
              title: 'Error!',
              text: 'Failed to forward inquiry. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            });
          }
        })
      );
    } else {
      this.markFormGroupTouched(this.salesPersonForm);
    }
  }

  private resetForm(): void {
    this.salesPersonForm.reset();
    this.selectedInquiry = null;
    this.isLoading = false;
  }

  private closeModal(): void {
    const modalElement = document.getElementById('kt_modal_inquiry_sales_person');
    if (modalElement) {
      const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
